import React, { createContext, useState, ReactNode, cloneElement, useContext } from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.module.css';
import useOutsideClick from '@/hooks/useClickOutside';

type Props = {
  children: ReactNode;
};

type BtnProps = {
  onClick: () => void;
  children: React.ReactElement;
};
type MenuItemsProps = {
  id: string | number;
  children: React.ReactNode;
};
const MenusContext = createContext<any>(null);

function Menus({ children }: Props) {
  const [openId, setOpenId] = useState('');
  const [position, setPosition] = useState(null);
  const close = () => setOpenId('');
  return (
    <MenusContext.Provider
      value={{
        openId,
        close,
        setOpenId,
        position,
        setPosition,
      }}
    >
      {children}
    </MenusContext.Provider>
  );
}

function Menu({ children }: Props) {
  return <div className={styles.menuWrapper}>{children}</div>;
}

function Toggle({ id, children }: MenuItemsProps) {
  const { openId, setOpenId, close, setPosition } = useContext(MenusContext);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const target = e.target as HTMLElement;
    const button = target.closest('button');
    if (button) {
      const rect = button.getBoundingClientRect();
      setPosition({
        x: window.innerWidth - rect.width - rect.x,
        y: rect.y + rect.height + 8,
      });
    }
    if (openId === '' || openId !== id) {
      setOpenId(id);
    } else {
      close();
    }
  };

  return cloneElement(children as React.ReactElement, {
    onClick: handleClick,
  });
}

function List({ id, children }: MenuItemsProps) {
  const { openId, position, close } = useContext(MenusContext);
  const ref = useOutsideClick<HTMLUListElement>(close, false);
  if (openId !== id) return null;

  return createPortal(
    <ul
      ref={ref}
      className={styles.menuList}
      style={{
        top: position?.y,
        right: position?.x,
      }}
    >
      {children}
    </ul>,
    document.body,
  );
}

function Button({ children, onClick }: BtnProps) {
  const { close } = useContext(MenusContext);
  const handeAction = () => {
    onClick();
    close();
  };
  return <li onClick={handeAction}>{children}</li>;
}

Menus.Menu = Menu;
Menus.Toggle = Toggle;
Menus.List = List;
Menus.Button = Button;

export default Menus;
